<div id="content-section">
  <div id="content-main" class="responsive-content-main" [ngStyle]="{ 'margin-right': sidebarMaximized ? '720px' : '420px' }">
    <div id="content-sidebar" #matterSidebarElem [ngClass]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [ngStyle]="{ width: sidebarMaximized ? '700px' : '400px' }" style="position: fixed; right: 20px; overflow-y: scroll; z-index: 1025 !important">
      <div class="sticky-top">
        <small class="bg-white">
          <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
            <i class="fas" [ngClass]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
          </a>
        </small>
      </div>
      <app-matter-sidebar [loadingMatterPage]="loadingMatterPage" [permissions]="permissions" #matterSidebar [matter_id]="matter_id"></app-matter-sidebar>
    </div>
    <div id="content-inner" style="padding: 10px 20px 10px 20px">
      <div class="container-fluid container-shadow py-3 px-3">
        <div class="alert alert-danger mb-0" *ngIf="matterInfoLoadError">
          {{ matterInfoLoadError }}
        </div>
        <div class="text-center" *ngIf="!matter_info.case_name && !matterInfoLoadError">
          <i class="fas fa-spinner fa-pulse fa-3x"></i>
        </div>
        <app-matter-info (openStatus)="showStatus = true" [matter_info]="matter_info" *ngIf="matter_info.case_name"></app-matter-info>
        <!-- Frozen due to conflicts banner -->
        <div class="alert alert-danger mt-3 mb-0" *ngIf="matter_info.frozen_due_to_conflicts">
          <h5 class="alert-heading mb-2"><i class="fa fa-lock mr-2"></i>Matter Frozen - Conflict Approval Required</h5>
          <p class="mb-2">This matter has potential conflicts that require approval before work can proceed.</p>
          <p class="mb-0 small">Go to <strong>Administration > Conflict Check</strong> in the sidebar to review and approve conflicts. Only the lead attorney or an admin can approve.</p>
        </div>
        <div class="mt-2" *ngIf="matter_info.case_name && matter_id == 697">
          <button class="btn btn-danger btn-sm" (click)="cleanTestData()">
            <i class="fas fa-trash"></i> Clean Test Data
          </button>
        </div>
      </div>
      <div class="my-3"></div>
      <tabset type="pills" *ngIf="!loadingMatterPage">
        <tab heading="Details" [active]="showDetails">
          <div class="container-fluid container-shadow" *ngIf="matter_info.notice">
            <h5 class="bg-primary text-white py-3 px-3 mb-0 accordion-header" style="margin-left: -15px; cursor: pointer" (click)="noticeCollapsed = !noticeCollapsed">
              <i class="fas fa-fw" [ngClass]="{'fa-chevron-down': !noticeCollapsed, 'fa-chevron-right': noticeCollapsed}"></i>
              Notice
            </h5>
            <div *ngIf="!noticeCollapsed">
              <h5 class="py-3 red" [innerHTML]="matter_info.notice | safeHtml"></h5>
            </div>
          </div>
          <div class="container-fluid container-shadow" *ngIf="matter_info.notes">
            <h5 class="bg-primary text-white py-3 px-3 mb-0 accordion-header" style="margin-left: -15px; cursor: pointer" (click)="notesCollapsed = !notesCollapsed">
              <i class="fas fa-fw" [ngClass]="{'fa-chevron-down': !notesCollapsed, 'fa-chevron-right': notesCollapsed}"></i>
              Notes
            </h5>
            <div *ngIf="!notesCollapsed">
              <h5 class="py-3" style="font-size: 100%" [innerHTML]="matter_info.notes | safeHtml"></h5>
            </div>
          </div>
          <div class="my-3" *ngIf="matter_info.notes || matter_info.notice"></div>
          <div class="container-fluid container-shadow">
            <h5 class="bg-primary text-white py-3 px-3 mb-0 accordion-header" style="margin-left: -15px; cursor: pointer" (click)="contactsCollapsed = !contactsCollapsed">
              <i class="fas fa-fw" [ngClass]="{'fa-chevron-down': !contactsCollapsed, 'fa-chevron-right': contactsCollapsed}"></i>
              Contacts
              <a href="javascript: void(0)" (click)="showNewInvolvementForm = !showNewInvolvementForm; $event.stopPropagation()" class="text-white">
                <i class="fas fa-plus-circle"></i>
              </a>
            </h5>
            <div *ngIf="!contactsCollapsed">
              <div class="py-3" *ngIf="showNewInvolvementForm">
                <div class="row">
                  <div class="col-12">
                    <div class="card" style="width: 25rem">
                      <div class="card-body">
                        <app-involvement-form [newInvolvementForm]="true" (formResult)="involvementFormResult($event)" [matter_id]="matter_id"></app-involvement-form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="py-3">
                <app-involvements #involvements [matter_id]="matter_id" [matter_type_name]="matter_info.matter_type_name"></app-involvements>
              </div>
            </div>
          </div>
          <div class="my-3"></div>
          <div class="container-fluid container-shadow">
            <h5 class="bg-primary text-white py-3 px-3 mb-0 accordion-header" style="margin-left: -15px; cursor: pointer" (click)="historiesCollapsed = !historiesCollapsed">
              <i class="fas fa-fw" [ngClass]="{'fa-chevron-down': !historiesCollapsed, 'fa-chevron-right': historiesCollapsed}"></i>
              Histories
              <a href="javascript: void(0)" (click)="showNewMatterHistoryForm = !showNewMatterHistoryForm; $event.stopPropagation()" class="text-white">
                <i class="fas fa-plus-circle"></i>
              </a>
            </h5>
            <div *ngIf="!historiesCollapsed">
              <div class="py-3" *ngIf="showNewMatterHistoryForm">
                <div class="row">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <app-matter-history-form (formResult)="matterHistoryFormResult($event)" [matter_id]="matter_id"></app-matter-history-form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="py-3">
                <app-matter-histories #matter_histories [matter_id]="matter_id"></app-matter-histories>
              </div>
            </div>
          </div>
          <div class="my-3"></div>
        </tab>
        <tab heading="Documents" [active]="showDocuments">
          <div class="my-2"></div>
          <tabset>
            <tab heading="List of documents" [active]="listDocumentTabActive">
              <app-matter-documents-list (showDocuments)="showDocuments = true; !componentDestroyed && changeDetectorRef.detectChanges()" [matter_id]="matter_id" (openDocument)="addToDocumentShow($event)"></app-matter-documents-list>
            </tab>
            <tab *ngIf="matter_info?.card_printing_available" heading="Card Printing">
              <iframe [src]="getCardPrintingUrl() | safeUrl" title="Wallet card printing"
                      style="width: 100%; height: 1050px; border: none;" frameborder="0"></iframe>
            </tab>
            <tab *ngIf="matterStoreService.documentEditor" [heading]="documentFormTitle()" [active]="newDocumentTabActive">
              <app-document-form [matter_info]="matter_info" [matter_id]="matter_id"></app-document-form>
            </tab>
            <tab *ngIf="matterStoreService.documentUploader" heading="New Document Upload">
              <app-document-form-upload [matter_id]="matter_id"></app-document-form-upload>
            </tab>
            <tab *ngIf="showDocumentsSectionAdditionalTabs" heading="New File Share">
              <app-shares-new [noRedirection]="true"></app-shares-new>
            </tab>
            <tab *ngIf="showDocumentsSectionAdditionalTabs" heading="New Email">
              <app-email-new [noRedirection]="true"></app-email-new>
            </tab>
            <tab *ngFor="let doc of docs; let i = index" [active]="doc.active">
              <ng-template tabHeading>
                {{ doc.name }}&nbsp;
                <a href="javascript:void(0)" class="text-dark" (click)="removeFromDocumentShow(i)">
                  <i class="fas fa-times"></i>
                </a>
              </ng-template>
              <app-document-show [doc]="doc" (documentDeleted)="removeFromDocumentShow(i, true)"></app-document-show>
            </tab>
          </tabset>
        </tab>
        <tab heading="AI Research">
          <div class="container-fluid py-0 px-0 tab-content-border">
            <iframe [src]="getAiDocumentsUrl() | safeUrl"
                    style="width: 100%; height: 980px; border: none;"
                    frameborder="0">
            </iframe>
          </div>
        </tab>
        <tab heading="Accounting" (selectTab)="accountingTabLoaded = true">
          <div *ngIf="accountingTabLoaded">
          <div class="my-2"></div>
          <tabset>
            <tab heading="Billings">
              <div class="container-fluid container-shadow py-3 px-2" *ngIf="matter_id">
                <app-billings-index [matter_id]="matter_id"></app-billings-index>
              </div>
            </tab>
            <tab heading="Bills">
              <div class="container-fluid container-shadow py-3 px-2">
                <app-bill-index [matter_id]="matter_id" *ngIf="matter_id"></app-bill-index>
              </div>
            </tab>
            <tab heading="Invoices">
              <div class="container-fluid container-shadow py-3 px-2">
                <app-matter-invoice-index [matter_id]="matter_id"></app-matter-invoice-index>
              </div>
            </tab>
            <tab heading="Online Payments">
              <div class="container-fluid container-shadow py-3 px-2">
                <app-online-payments-index [matterId]="matter_id" *ngIf="matter_id"></app-online-payments-index>
              </div>
            </tab>
            <tab heading="Retainers">
              <div class="container-fluid container-shadow py-3 px-2">
                <div class="form-row align-items-end">
                  <div class="col-md-3">
                    <label for="payload-retainer-amount">Amount</label>
                    <input id="payload-retainer-amount" type="number" min="0.01" step="0.01" class="form-control" [(ngModel)]="retainerRequest.amount" />
                  </div>
                  <div class="col-md-6">
                    <label for="payload-retainer-description">Description</label>
                    <input id="payload-retainer-description" type="text" class="form-control" [(ngModel)]="retainerRequest.description" placeholder="Matter retainer" />
                  </div>
                  <div class="col-md-3">
                    <button class="btn btn-primary btn-block" [disabled]="retainerRequestSaving || !retainerRequest.amount" (click)="requestPayloadRetainer()">
                      <i class="fas fa-link mr-1"></i>
                      Request Retainer
                    </button>
                  </div>
                </div>
                <div class="table-responsive mt-3">
                  <table class="table table-sm table-striped mb-0">
                    <thead>
                      <tr>
                        <th>Created</th>
                        <th>Amount</th>
                        <th>Status</th>
                        <th>Client</th>
                        <th>Link</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngIf="retainerRequestsLoading">
                        <td colspan="5" class="text-center">
                          <i class="fas fa-spinner fa-pulse"></i>
                        </td>
                      </tr>
                      <tr *ngFor="let request of retainerRequests">
                        <td>{{ request.created_at | date: 'short' }}</td>
                        <td>{{ request.amount | currency: 'USD':'symbol':'1.2-2' }}</td>
                        <td>{{ request.status }}</td>
                        <td>{{ request.contact_name }}</td>
                        <td>
                          <a [href]="request.payment_url" target="_blank" rel="noopener" class="btn btn-sm btn-outline-primary" [class.disabled]="!request.payment_url">
                            <i class="fas fa-external-link-alt"></i>
                          </a>
                          <button class="btn btn-sm btn-outline-secondary ml-1" [disabled]="!request.payment_url" (click)="copyRetainerPaymentUrl(request.payment_url)">
                            <i class="fas fa-copy"></i>
                          </button>
                        </td>
                      </tr>
                      <tr *ngIf="!retainerRequestsLoading && retainerRequests.length == 0">
                        <td colspan="5" class="text-center text-muted">No retainer requests</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </tab>
          </tabset>
          </div>
        </tab>
        <tab heading="Outgoing">
          <div class="container-fluid container-shadow py-3 px-2">
            <app-outgoing-jobs-index #outgoingJobsIndex [matter_id]="matter_id" [minimalMode]="true"></app-outgoing-jobs-index>
          </div>
        </tab>
        <tab heading="Reminders">
          <div class="container-fluid container-shadow py-3 px-2">
            <app-reminder-common [reminderable_type]="'Matter'" [reminderable_id]="matter_id"></app-reminder-common>
          </div>
        </tab>
        <tab heading="Texts">
          <div class="container-fluid container-shadow py-3 px-2">
            <app-text-document-index [matterId]="matter_id" *ngIf="matter_id"></app-text-document-index>
          </div>
        </tab>
        <tab heading="Status" [active]="showStatus">
          <app-matter-status [matter_id]="matter_id"></app-matter-status>
        </tab>
      </tabset>
    </div>
  </div>
</div>
<app-sidebar-toggle-btn [sidebarOpen]="sidebarOpen" (onClick)="sidebarOpen = !sidebarOpen"></app-sidebar-toggle-btn>
<ng-template #matter_history_form let-c="close" let-d="dismiss">
  <div class="modal-body">
    <app-matter-history-form [matter_id]="modalParams.matter_id" [parent_id]="modalParams.parent_id" (formResult)="c($event)"></app-matter-history-form>
  </div>
</ng-template>
